import { Component } from "@angular/core";
import {
  NavController,
  ToastController,
  LoadingController,
  ViewController,
  NavParams,
} from "ionic-angular";

import { Master } from "@providers/asset/index";
import { FormClassificationPage } from "../form_classification/page";

@Component({
  selector: "page-classification",
  templateUrl: "page.html",
})
export class ClassificationPage {
  List: any = [];
  pilihModal = 0;
  selectedID = [0];

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ) {
    this.pilihModal = navParams.get("pilih");
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList() {
    let loading = this.loadingCtrl.create({
      content: "Please wait...",
    });
    loading.present();

    let params = { parent_id: this.selectedID[this.selectedID.length - 1] };

    this.masterApi.getClassification(params).subscribe(
      (resp: any) => {
        if (resp.data.length > 0) {
          this.List = resp.data;
        } else {
          this.toastCtrl
            .create({
              message: "Data sub clasification not found",
              duration: 3000,
              position: "top",
            })
            .present();
          this.selectedID.pop();
        }
        loading.dismiss();
      },
      (err) => {
        this.selectedID.pop();
        loading.dismiss();
      }
    );
  }

  select(item) {
    let data = { item: item };
    this.viewCtrl.dismiss(data);
  }

  getSub(item, e) {
    // if(e.toElement.className=='button-inner'){
    //   return;
    // }
    this.selectedID.push(item.id);
    this.getList();
  }

  toParent() {
    this.selectedID.pop();
    this.getList();
  }

  add(id) {
    let params = { parent_id: id };
    this.navCtrl.push(FormClassificationPage, params);
  }

  edit(item) {
    let params = { item: item };
    this.navCtrl.push(FormClassificationPage, params);
  }

  closeModal() {
    let data = { item: "" };
    this.viewCtrl.dismiss(data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/asset/classification/page.ts